import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';
import { ToastrNotificationService } from './toastr-notification.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  currentUser = {};

  constructor(
    private http: HttpClient,
    public router: Router,
    private toastr: ToastrNotificationService
  ) {}

  get endpoint(): string {
    let url = environment.apiUrl || '';
    if (url && !url.endsWith('/')) {
      url += '/';
    }
    return url;
  }

  private buildUrl(path: string): string {
    const base = this.endpoint;
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${cleanPath}`;
  }

  // Sign-up
  signUp(user: User): Observable<any> {
    let api = this.buildUrl('register-user');
    return this.http.post(api, user).pipe(catchError(this.handleError));
  }

  // Sign-in
  signIn(user: any) {
    return this.http.post<any>(this.buildUrl('admin/login'), user).subscribe({
      next: (res: any) => {
        if (res.success) {
          localStorage.setItem('access_token', res.admin.sessionToken);
          this.currentUser = {
            username: res.admin.username,
            image: res.admin.image,
          };
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          this.toastr.success('Login Successfull', 'Success');
          this.router.navigate(['home/']);
        } else {
          this.toastr.error(res?.error ? res?.error : 'Login Failed', 'Error');
        }
      },
      error: (error) => {
        this.toastr.error(
          error.error?.messages || error.message || 'Login Failed',
          'Error'
        );
      },
      complete: () => {},
    });
  }

  getToken(): any {
    return localStorage.getItem('access_token');
  }

  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem('access_token');
    return authToken !== null && authToken !== 'null' && authToken !== 'undefined' && authToken !== '';
  }

  doLogout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userId');
    localStorage.removeItem('currentUser');
    this.router.navigate(['login']);
  }

  // User profile
  getUserProfile(id: any): Observable<any> {
    let api = this.buildUrl(`users/${id}`);
    return this.http.get(api, { headers: this.headers }).pipe(
      map((res) => {
        return res || {};
      }),
      catchError(this.handleError)
    );
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      msg = error.error.message;
    } else {
      msg = error.error?.messages || `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => new Error(msg));
  }
}
